module.exports = __webpack_public_path__ + "img/icon_take_away.cddc52cc.svg";